<div class="flex wrapper" [ngClass]="{ 'toggle-group-disabled': disabled() }">
    <ng-content></ng-content>
</div>
